import './ReviewAttribute.scss';

import React from 'react';
import {IconSize} from "../../../services/IconConstants";
import TickIcon from "../../../icons/TickIcon";

interface Props {
    name: string;
    activeAttributes: string[];
    onPress: () => void;
}

const ReviewAttribute = ({name, activeAttributes, onPress}: Props) => {

    let active = activeAttributes.includes(name);

    return (
        <div className={"reviewAttribute_container"} onClick={onPress}>
            {active && <TickIcon size={IconSize.xl} />}
            {!active && <div className={"reviewAttribute_icon"} />}

            <span className={"reviewAttribute_txt"}>{name}</span>
        </div>
    )
}

export default ReviewAttribute;
